import { useMutationBuilder } from "src/query/useBuilders";
import { 
  identifyUserForAdoption,
  trackEventForAdoption,
} from "src/services/adoption";
import { TrackEventForAdoptionRequest } from "src/types/adoption";
import { ADOPTION, IDENTIFY } from "src/query/queryKeys";

export const useIdentifyUserForAdoption = () => {
  return useMutationBuilder(
    [ADOPTION, IDENTIFY],
    identifyUserForAdoption
  );
};

export const useTrackEventForAdoption = (key: string) => {
  return useMutationBuilder(
    [ADOPTION, key],
    (event: TrackEventForAdoptionRequest) => trackEventForAdoption(event)
  );
};